export default __webpack_public_path__ + "static/assets/60b1cb13c0880353789f643605c895cd.png";